// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"3016fef3","501":"43a5cf4b","846":"665a7d19","999":"973aa3b0"}[chunkId] + ".chunk.js";
};